var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350.176,
    height: 117.897,
    viewBox: "0 0 350.176 117.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_212_diversity_flatline",
    "data-name": "#212_diversity_flatline",
    transform: "translate(-27.497 -91.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9584",
    "data-name": "Trazado 9584",
    d: "M293.3,111.51s9.7-18.92,11.35-19.59,6.45,1.31,6.11,2.26-2.37,10.07-2.37,10.07,5.22-3.37,5.76-2-5.84,8.18-5.84,8.18l-8.69,14.51Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9585",
    "data-name": "Trazado 9585",
    d: "M299.62,125.44h0a.51.51,0,0,1-.44-.29l-6.32-13.42a.48.48,0,0,1,0-.45c2.29-4.48,9.91-19.15,11.61-19.84s5.25.67,6.39,1.77a1.06,1.06,0,0,1,.4,1.15c-.24.65-1.41,5.81-2.08,8.81,1.47-.86,3.77-2,4.83-1.7a1,1,0,0,1,.64.58c.58,1.44-3.43,6-5.9,8.68l-8.67,14.46a.5.5,0,0,1-.46.25Zm-5.75-13.92,5.8,12.31,8.2-13.68.07-.09c2.87-3.07,5.86-6.87,5.73-7.64-.41-.21-2.8.85-5,2.27a.53.53,0,0,1-.57,0,.52.52,0,0,1-.21-.54c.08-.36,1.94-8.76,2.35-10a3.9,3.9,0,0,0-1.56-1c-1.52-.66-3.17-1-3.84-.69-1.04.54-6.41,10.17-10.97,19.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9586",
    "data-name": "Trazado 9586",
    d: "M294,141.42l10.56-23.81-11.81-10s-29,37.36-16.86,46.94l27.7,27.16L329,163.85Z",
    fill: "#8e81f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9587",
    "data-name": "Trazado 9587",
    d: "M327.1,125a15.61,15.61,0,0,1,6.95-9.23c5.91-3.79,22.1-1.28,25.07,5.34s-5.71,24-5.71,24l-27.8,7.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9588",
    "data-name": "Trazado 9588",
    d: "M325.61,153.1a.47.47,0,0,1-.32-.12.49.49,0,0,1-.19-.42L326.58,125a.17.17,0,0,1,0-.07,16,16,0,0,1,7.19-9.57c3.48-2.23,10.6-2.48,16.93-.59,4.55,1.36,7.71,3.54,8.88,6.16,3,6.76-5.36,23.69-5.71,24.41a.55.55,0,0,1-.33.27l-27.8,7.5Zm2-28-1.44,26.83,26.88-7.26c1-2,8.26-17.38,5.6-23.32-1-2.3-4-4.34-8.24-5.59-6-1.78-12.88-1.58-16.08.47a15.31,15.31,0,0,0-6.72,8.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9589",
    "data-name": "Trazado 9589",
    d: "M352.07,204c2-14.89,3.3-29.65,1.65-32.46-5.65-9.62-31.16-3.74-35.89-1.58-1.84.84-.74,15.91-3.74,34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9590",
    "data-name": "Trazado 9590",
    d: "M376,204.7s5.15-25.43-2.62-33-26.4-6.44-26.4-6.44-29.49-4.07-38.55.59c-3.69,1.9-8.45,18.51-12.9,38.15h25.48l7-33.84,22.84.73L343.35,204Z",
    fill: "#8e81f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9591",
    "data-name": "Trazado 9591",
    d: "M330,156.9l-2,13.29s.91,8.79,9.81,7.68a17.85,17.85,0,0,0,12.85-8.35l2.69-24.44s-6-4.16-2.55-17.88a82.74,82.74,0,0,1-23.7-2.2s-4.75,17.42-4.47,24.25S330,156.9,330,156.9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9592",
    "data-name": "Trazado 9592",
    d: "M336.37,178.49a8.39,8.39,0,0,1-5.37-1.75,10.43,10.43,0,0,1-3.46-6.5.572.572,0,0,1,0-.13l1.89-12.79c-1.72-.37-7.08-2-7.33-8-.27-6.83,4.29-23.69,4.49-24.41a.51.51,0,0,1,.62-.36,82.93,82.93,0,0,0,23.6,2.18.57.57,0,0,1,.44.18.48.48,0,0,1,.1.46c-3.33,13.16,2.29,17.3,2.35,17.34a.52.52,0,0,1,.22.48l-2.7,24.44a.35.35,0,0,1-.06.19,18.2,18.2,0,0,1-13.24,8.62,14.214,14.214,0,0,1-1.55.05Zm-7.79-8.3a9.44,9.44,0,0,0,3.07,5.75,8,8,0,0,0,6.15,1.42,17.44,17.44,0,0,0,12.42-8l2.65-24.05c-1.14-1-5.5-5.6-2.67-17.56a85.139,85.139,0,0,1-22.74-2.13c-.75,2.86-4.56,17.57-4.31,23.61.25,6.31,6.66,7.12,6.93,7.15a.52.52,0,0,1,.35.2.5.5,0,0,1,.11.39Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9593",
    "data-name": "Trazado 9593",
    d: "M329,163.85s3.39,1.08,7.62-2.16,4.15-5.41,4.15-5.41a16.29,16.29,0,0,1-10.74.62Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9594",
    "data-name": "Trazado 9594",
    d: "M330.47,164.52a5.75,5.75,0,0,1-1.63-.2.5.5,0,0,1-.34-.54l1-7a.52.52,0,0,1,.23-.35.56.56,0,0,1,.42-.05,15.87,15.87,0,0,0,10.38-.59.49.49,0,0,1,.71.43c0,.25,0,2.52-4.35,5.83a10.6,10.6,0,0,1-6.42,2.47Zm-1.47-.67Zm.56-.39c1,.16,3.59.26,6.76-2.17a11,11,0,0,0,3.73-4.2,16.52,16.52,0,0,1-9.62.45Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9595",
    "data-name": "Trazado 9595",
    d: "M338,137.54s-4.92,7.14-3.79,8.41,4.35.48,4.35.48",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9596",
    "data-name": "Trazado 9596",
    d: "M336.53,147.19a3.56,3.56,0,0,1-2.69-.9c-1.27-1.42,2.2-6.79,3.75-9a.52.52,0,0,1,.85.59c-2.45,3.55-4.27,7.25-3.83,7.76.75.84,3.08.51,3.84.33a.514.514,0,0,1,.24,1,10.162,10.162,0,0,1-2.16.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9597",
    "data-name": "Trazado 9597",
    d: "M337.22,152.1h-.34c-4.12-.17-7.1-3.44-7.23-3.58a.5.5,0,0,1,.75-.67s2.84,3.1,6.53,3.25a7.93,7.93,0,0,0,5.8-2.43.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71A9,9,0,0,1,337.22,152.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1223",
    "data-name": "Elipse 1223",
    cx: 1.96,
    cy: 0.85,
    rx: 1.96,
    ry: 0.85,
    transform: "translate(342.797 138.548) rotate(-87.79)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1224",
    "data-name": "Elipse 1224",
    cx: 1.96,
    cy: 0.85,
    rx: 1.96,
    ry: 0.85,
    transform: "matrix(0.04, -1, 1, 0.04, 331.047, 137.115)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9598",
    "data-name": "Trazado 9598",
    d: "M348.22,140.91a11.83,11.83,0,0,1,3.34-3.08,4.14,4.14,0,0,1,2.33-.75,3.69,3.69,0,0,1,1.85.77,7.12,7.12,0,0,1,2.85,5,5.53,5.53,0,0,1-.39,2.7,6.23,6.23,0,0,1-3,3,18.11,18.11,0,0,1-4.14,1.3",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9599",
    "data-name": "Trazado 9599",
    d: "M351,150.38a.52.52,0,0,1-.11-1,18.6,18.6,0,0,0,4-1.26,5.73,5.73,0,0,0,2.8-2.71,5.051,5.051,0,0,0,.35-2.46,6.59,6.59,0,0,0-2.65-4.66,3,3,0,0,0-1.58-.67,3.74,3.74,0,0,0-2,.67,11.471,11.471,0,0,0-3.19,2.94.51.51,0,0,1-.72.11.52.52,0,0,1-.12-.72,12.571,12.571,0,0,1,3.49-3.21,4.59,4.59,0,0,1,2.63-.82,4.07,4.07,0,0,1,2.12.86,7.61,7.61,0,0,1,3.06,5.41,6.12,6.12,0,0,1-.42,3,6.84,6.84,0,0,1-3.29,3.23,18.85,18.85,0,0,1-4.25,1.33Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9600",
    "data-name": "Trazado 9600",
    d: "M368.9,189.54c-2.61,3.38-6.07,8.58-9.78,14.49h9.78Z",
    fill: "#8e81f3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    y1: 22.36,
    x2: 9.78,
    transform: "translate(359.12 181.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9601",
    "data-name": "Trazado 9601",
    d: "M359.12,204.55a.54.54,0,0,1-.21-.05.51.51,0,0,1-.26-.68l9.78-22.36a.52.52,0,0,1,.68-.27.51.51,0,0,1,.26.68l-9.78,22.37a.51.51,0,0,1-.47.31Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9602",
    "data-name": "Trazado 9602",
    d: "M300.55,107.62a.5.5,0,0,1-.31-.1.51.51,0,0,1-.11-.72,8.192,8.192,0,0,1,8.38-3,.52.52,0,0,1,.39.62.51.51,0,0,1-.62.38c-.19,0-4.62-1-7.32,2.66a.49.49,0,0,1-.41.16Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9603",
    "data-name": "Trazado 9603",
    d: "M119.59,179.62s0-5.2,16.16-13.85,40.72-6.33,49.32-1.2,12.8,6.14,16.3,17.54a80.769,80.769,0,0,1,3.33,22.13H116.9Z",
    fill: "#ea6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9604",
    "data-name": "Trazado 9604",
    d: "M150.41,188.87c1.9,1.59,10.56,3.15,12.55,2.63,5.28-1.36,10.88-3.24,14.12-7.82,1.84-2.59,2.7-5.77,3.4-8.91.82-3.68,1.44-7.57.39-11.18-3.57-12.17-22.32-13.42-31.65-8.49C135.84,162.17,141,181,150.41,188.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9605",
    "data-name": "Trazado 9605",
    d: "M161.82,192.1c-3.25,0-10-1.42-11.73-2.84h0c-6.24-5.19-10.19-14.55-9.39-22.25a15.17,15.17,0,0,1,8.3-12.35c6.43-3.4,16.22-3.72,23.26-.74,4.71,2,7.85,5.28,9.1,9.53,1.08,3.68.45,7.67-.38,11.43-.66,3-1.52,6.33-3.48,9.09-3.27,4.62-8.86,6.58-14.41,8A5.379,5.379,0,0,1,161.82,192.1Zm-11.09-3.61c1.72,1.44,10.14,3,12.1,2.53,5.37-1.39,10.76-3.27,13.84-7.63,1.86-2.61,2.69-5.88,3.32-8.73.81-3.63,1.41-7.46.4-10.93-1.16-3.95-4.11-7-8.53-8.89-6.68-2.82-16.31-2.52-22.41.7a14.22,14.22,0,0,0-7.75,11.58c-.77,7.39,3,16.38,9,21.37Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9606",
    "data-name": "Trazado 9606",
    d: "M155.08,110.1c-9.08,1.59-17.24,7.07-17.06,17.22.1,6.18,3.44,12,8.1,16.09,6.83,6,16.93,8.34,25.36,5a20.86,20.86,0,0,0,13-17.74c.34-6.11-2.38-16.16-8.81-18.38-2.46-.86-5.5,1.1-5.5,1.1C169,109.87,158.85,109.43,155.08,110.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9607",
    "data-name": "Trazado 9607",
    d: "M163.36,150.38a27,27,0,0,1-17.54-6.62c-5.14-4.5-8.16-10.49-8.26-16.43-.16-9.12,6.36-15.73,17.44-17.68,3.77-.67,13.39-.33,15.37,3.11,1-.53,3.37-1.61,5.45-.89,6.5,2.25,9.47,12.39,9.12,18.84a21.43,21.43,0,0,1-13.29,18.14A22.54,22.54,0,0,1,163.36,150.38Zm-4.6-40.08a22,22,0,0,0-3.6.25h0c-10.6,1.86-16.84,8.13-16.69,16.76.1,5.69,3,11.43,7.95,15.76,7,6.07,17,8.06,24.9,4.93A20.5,20.5,0,0,0,184,130.66c.33-6.16-2.43-15.82-8.51-17.92-2.22-.77-5.08,1-5.11,1.05a.46.46,0,0,1-.4,0,.5.5,0,0,1-.28-.29C168.94,111.16,163.14,110.3,158.76,110.3Zm-3.68-.2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9608",
    "data-name": "Trazado 9608",
    d: "M171.16,158.09l.08,13.25s-1.34,7.41-9.4,5.15a16.67,16.67,0,0,1-10.71-9.5s-.67-27.92-.83-36.33c9.79-.16,20.57-6.47,20.57-6.47s3.37,5.06,4.83,6.66a20.261,20.261,0,0,1,3,4c1.36,2.55,1.31,5.73,1.24,8.55a54.811,54.811,0,0,1-1,10C177.68,159.63,171.16,158.09,171.16,158.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9609",
    "data-name": "Trazado 9609",
    d: "M164.7,177.38a11.08,11.08,0,0,1-3-.45,17,17,0,0,1-11-9.78.4.4,0,0,1,0-.15c0-.28-.67-28-.83-36.33a.49.49,0,0,1,.13-.33.43.43,0,0,1,.32-.14c9.56-.15,20.25-6.34,20.35-6.4a.46.46,0,0,1,.61.14s3.37,5.05,4.79,6.6a20.239,20.239,0,0,1,3.09,4.09c1.44,2.68,1.36,6.07,1.3,8.78a55,55,0,0,1-1,10.06,6.2,6.2,0,0,1-2.69,4.22,7.83,7.83,0,0,1-5.11.94l.08,12.71a7.92,7.92,0,0,1-3.31,5A6.79,6.79,0,0,1,164.7,177.38ZM151.58,166.9A16.35,16.35,0,0,0,162,176.05a7.23,7.23,0,0,0,5.94-.45,7.15,7.15,0,0,0,2.89-4.34l-.09-13.17a.46.46,0,0,1,.56-.45,7.35,7.35,0,0,0,5-.72,5.4,5.4,0,0,0,2.28-3.63,54.241,54.241,0,0,0,1-9.9c.06-2.74.13-5.86-1.19-8.33a19.45,19.45,0,0,0-3-3.9c-1.26-1.38-3.84-5.17-4.64-6.36-2,1.09-11.32,6-20,6.3C150.93,139.69,151.54,165.26,151.58,166.9Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9610",
    "data-name": "Trazado 9610",
    d: "M171.08,164.6s-5.37.23-8.83-3.35-2.95-7.2-2.95-7.2,5.82,3.9,11.86,4Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9611",
    "data-name": "Trazado 9611",
    d: "M170.84,165c-1.15,0-5.75-.21-8.91-3.48-3.57-3.7-3.09-7.41-3.07-7.57a.484.484,0,0,1,.69-.34s5.78,3.83,11.62,4a.44.44,0,0,1,.43.44l-.08,6.51a.43.43,0,0,1-.42.44Zm.24-.44Zm-11.36-9.76a9.48,9.48,0,0,0,2.84,6.1c2.74,2.84,6.79,3.18,8.09,3.22l.06-5.65a25.61,25.61,0,0,1-10.99-3.63Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9612",
    "data-name": "Trazado 9612",
    d: "M166,136.94s4.26,6.37,3.25,7.47-3.85.38-3.85.38",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9613",
    "data-name": "Trazado 9613",
    d: "M167.25,145.47a9,9,0,0,1-2-.25.444.444,0,0,1,.22-.86c.67.17,2.74.5,3.42-.24.4-.45-1.17-3.75-3.29-6.93a.44.44,0,1,1,.73-.49c1.34,2,4.34,6.78,3.21,8A3,3,0,0,1,167.25,145.47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1225",
    "data-name": "Elipse 1225",
    cx: 0.73,
    cy: 1.37,
    rx: 0.73,
    ry: 1.37,
    transform: "matrix(0.999, -0.039, 0.039, 0.999, 170.783, 133.62)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1226",
    "data-name": "Elipse 1226",
    cx: 1.37,
    cy: 0.73,
    rx: 1.37,
    ry: 0.73,
    transform: "translate(158.496 135.931) rotate(-88.3)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9614",
    "data-name": "Trazado 9614",
    d: "M153,139.27c-1.41-2-3.6-5.58-6.54-4.48a4.88,4.88,0,0,0-2,1.48c-2.35,2.78-2,6.49-.44,9.55,1.34,2.64,5.55,6.65,8.44,3.33",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9615",
    "data-name": "Trazado 9615",
    d: "M149.94,150.86a3.594,3.594,0,0,1-.47,0c-2.63-.32-5-3.12-5.83-4.8-1.88-3.71-1.69-7.47.5-10.06a5.31,5.31,0,0,1,2.17-1.61c3-1.13,5.26,2,6.73,4.16l.34.48a.45.45,0,0,1-.11.64.44.44,0,0,1-.63-.11l-.35-.49c-1.38-2-3.28-4.71-5.66-3.83a4.49,4.49,0,0,0-1.79,1.35c-2,2.3-2.09,5.69-.38,9.06.83,1.63,3,4,5.12,4.31a2.85,2.85,0,0,0,2.56-1.08.47.47,0,0,1,.65,0,.46.46,0,0,1,0,.65,3.77,3.77,0,0,1-2.85,1.33Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9616",
    "data-name": "Trazado 9616",
    d: "M166.49,151.71a6.23,6.23,0,0,1-.74,0c-4.21-.48-7.14-4.82-7.26-5a.44.44,0,0,1,.12-.61.45.45,0,0,1,.62.12s2.83,4.18,6.62,4.61a6.73,6.73,0,0,0,5.42-2.14.442.442,0,1,1,.61.64A7.84,7.84,0,0,1,166.49,151.71Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9617",
    "data-name": "Trazado 9617",
    d: "M134,204.74a.5.5,0,0,1-.5-.5V183.48a.5.5,0,1,1,1,0v20.76a.5.5,0,0,1-.5.5Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9618",
    "data-name": "Trazado 9618",
    d: "M186.79,204.77a.5.5,0,0,1-.49-.41l-4.1-21.67a.5.5,0,0,1,.4-.58.49.49,0,0,1,.58.4l4.1,21.67a.49.49,0,0,1-.4.58Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9619",
    "data-name": "Trazado 9619",
    d: "M162.08,174.87s-11.19,11.85-10.62,23.46l18.86,2.16s-3.44-20.59-1.31-25.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9620",
    "data-name": "Trazado 9620",
    d: "M170.32,201h0l-18.87-2.16a.5.5,0,0,1-.44-.48c-.58-11.69,10.29-23.33,10.76-23.83a.51.51,0,0,1,.35-.15l6.94-.12a.5.5,0,0,1,.47.69c-2.06,5,1.3,25.26,1.34,25.47a.5.5,0,0,1-.13.42.52.52,0,0,1-.42.16Zm-18.38-3.11,17.79,2c-.56-3.46-2.93-19.12-1.41-24.66l-6,.1c-1.32,1.43-10.63,12.12-10.38,22.55Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9621",
    "data-name": "Trazado 9621",
    d: "M160.88,188.12h-.08a.49.49,0,0,1-.41-.57,24.94,24.94,0,0,1,4.37-10.93.49.49,0,0,1,.7-.08.5.5,0,0,1,.08.7,24.62,24.62,0,0,0-4.17,10.47.5.5,0,0,1-.49.41Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9622",
    "data-name": "Trazado 9622",
    d: "M172.08,179.08a.48.48,0,0,1-.2,0,.49.49,0,0,1-.26-.65,42.2,42.2,0,0,0,2.51-7,13.39,13.39,0,0,0-.13-7.2.5.5,0,1,1,.95-.31,14.34,14.34,0,0,1,.15,7.73,41.739,41.739,0,0,1-2.56,7.19.5.5,0,0,1-.46.24Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9623",
    "data-name": "Trazado 9623",
    d: "M161,138.91h-5.62a3.59,3.59,0,0,1-3.59-3.58v-3.84a.5.5,0,0,1,.5-.5h11.8a.5.5,0,0,1,.5.5v3.84A3.59,3.59,0,0,1,161,138.91ZM152.83,132v3.34a2.59,2.59,0,0,0,2.59,2.58H161a2.59,2.59,0,0,0,2.59-2.58V132Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9624",
    "data-name": "Trazado 9624",
    d: "M175,138.91h-5.63a3.58,3.58,0,0,1-3.58-3.58v-3.84a.5.5,0,0,1,.5-.5H178.1a.5.5,0,0,1,.5.5v3.84A3.59,3.59,0,0,1,175,138.91ZM166.81,132v3.34a2.58,2.58,0,0,0,2.58,2.58H175a2.59,2.59,0,0,0,2.58-2.58V132Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_17",
    "data-name": "L\\xEDnea 17",
    x2: 6.16,
    transform: "translate(163.24 131.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9625",
    "data-name": "Trazado 9625",
    d: "M169.4,132h-6.16a.5.5,0,0,1,0-1h6.16a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9626",
    "data-name": "Trazado 9626",
    d: "M200.55,179.21c2.12-6.79,6-9.2,22.23-17.85s40-2.12,48.57,3S286.22,177.06,291,183s4.76,21,4.76,21H198.68S198.44,186,200.55,179.21Z",
    fill: "#a72054"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    x1: 1.92,
    y1: 22.81,
    transform: "translate(268.87 181.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9627",
    "data-name": "Trazado 9627",
    d: "M270.78,204.54a.49.49,0,0,1-.49-.45l-1.92-22.81a.5.5,0,1,1,1-.09L271.28,204a.49.49,0,0,1-.45.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9628",
    "data-name": "Trazado 9628",
    d: "M243.89,108c11.56,1,17,6.61,20.06,30.7,2.44,19,.88,17.5,13.26,29.12,0,0-11.28,15.45-34.11,15.45a69.59,69.59,0,0,1-38.64-11.89s17.26-10.54,16.94-20.9C220.27,114.42,232.33,107,243.89,108Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9629",
    "data-name": "Trazado 9629",
    d: "M243.1,183.78a70.72,70.72,0,0,1-38.94-12,.51.51,0,0,1-.2-.43.52.52,0,0,1,.24-.4c.17-.1,17-10.5,16.7-20.45-.6-19.22,2.5-32.19,9.22-38.55,3.62-3.43,8.27-4.93,13.81-4.45h0c12.81,1.1,17.6,8.38,20.52,31.14.27,2.13.5,4,.69,5.66,1.55,13,1.55,13,12.33,23.08l.08.08a.5.5,0,0,1,.06.66C277.5,168.28,265.92,183.78,243.1,183.78Zm-37.74-12.37a70.22,70.22,0,0,0,37.74,11.37,43.63,43.63,0,0,0,33.43-14.9c-10.79-10.13-10.81-10.23-12.38-23.45-.2-1.66-.42-3.53-.69-5.65-3.15-24.58-8.84-29.34-19.61-30.27-5.25-.46-9.64.95-13,4.18-6.51,6.15-9.5,18.87-8.91,37.79C222.2,160,208.56,169.35,205.36,171.41Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1227",
    "data-name": "Elipse 1227",
    cx: 12.96,
    cy: 18.51,
    rx: 12.96,
    ry: 18.51,
    transform: "translate(229.16 117.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9630",
    "data-name": "Trazado 9630",
    d: "M242.12,154.58c-11.83,0-13.46-9.14-13.46-19,0-10.2,0-19,13.46-19s13.46,8.81,13.46,19C255.58,145.44,254,154.58,242.12,154.58Zm0-37c-12.46,0-12.46,7.55-12.46,18,0,10.81,2.12,18,12.46,18s12.46-7.2,12.46-18c0-10.47,0-18.02-12.46-18.02Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9631",
    "data-name": "Trazado 9631",
    d: "M239.75,132.72s-4.93,5.79-4.06,7,3.75.81,3.75.81",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9632",
    "data-name": "Trazado 9632",
    d: "M238.38,141.09c-1,0-2.44-.18-3.1-1.08-.95-1.33,2.15-5.34,4.09-7.62a.5.5,0,1,1,.76.65c-2.42,2.84-4.3,5.82-4,6.38.56.78,2.6.7,3.27.61a.5.5,0,1,1,.14.99,10.308,10.308,0,0,1-1.16.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1228",
    "data-name": "Elipse 1228",
    cx: 1.05,
    cy: 1.47,
    rx: 1.05,
    ry: 1.47,
    transform: "translate(233.995 128.516) rotate(-0.573)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1229",
    "data-name": "Elipse 1229",
    cx: 1.05,
    cy: 1.47,
    rx: 1.05,
    ry: 1.47,
    transform: "matrix(1, -0.006, 0.006, 1, 244.489, 129.541)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9633",
    "data-name": "Trazado 9633",
    d: "M236,143.83l9.51-3.26a6,6,0,0,1-1.63,6.87C240.19,151.09,236,143.83,236,143.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9634",
    "data-name": "Trazado 9634",
    d: "M241.64,149a2.381,2.381,0,0,1-.46,0c-3-.4-5.5-4.66-5.6-4.85a.48.48,0,0,1,0-.42.54.54,0,0,1,.31-.3l9.5-3.27a.5.5,0,0,1,.61.25,6.58,6.58,0,0,1-1.72,7.45,3.66,3.66,0,0,1-2.64,1.14Zm-4.87-4.87c.73,1.1,2.58,3.58,4.54,3.84a2.54,2.54,0,0,0,2.22-.86,5.61,5.61,0,0,0,1.7-5.89Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9635",
    "data-name": "Trazado 9635",
    d: "M221.3,204.54a.5.5,0,0,1-.5-.5V184.17a.5.5,0,0,1,1,0V204a.5.5,0,0,1-.5.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9636",
    "data-name": "Trazado 9636",
    d: "M75.07,160s-17.47.56-24.35,13.2-7.17,31-7.17,31h79.82s-8.9-30.35-20.93-37.61S75.07,160,75.07,160Z",
    fill: "#ffd424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9637",
    "data-name": "Trazado 9637",
    d: "M55.64,199.47a.44.44,0,0,1-.22-.05.5.5,0,0,1-.23-.67c.33-.74,4.34-15.13,7-24.63a.518.518,0,1,1,1,.27c-.68,2.45-6.61,24-7,24.81a.51.51,0,0,1-.55.27Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9638",
    "data-name": "Trazado 9638",
    d: "M84.44,115.15s4.4-11.22-7-14.06S55.65,105.71,57,115.73s9,10.18,9,10.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9639",
    "data-name": "Trazado 9639",
    d: "M66,126.41h0c-.08,0-8.07-.29-9.45-10.61a12.87,12.87,0,0,1,4.37-11.58c4.27-3.81,10.52-5.17,16.72-3.62,3.44.86,5.83,2.56,7.11,5.05,2.24,4.34.28,9.46.19,9.68a.57.57,0,0,1-.21.25L66.22,126.34a.45.45,0,0,1-.22.07ZM72.56,101a16.37,16.37,0,0,0-11,4,11.88,11.88,0,0,0-4,10.7c1.19,8.85,7.33,9.66,8.36,9.74L84,114.81c.3-.87,1.62-5.18-.2-8.71-1.15-2.22-3.33-3.74-6.47-4.53A20,20,0,0,0,72.56,101Zm11.88,14.18Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9640",
    "data-name": "Trazado 9640",
    d: "M67.83,116.3a15.86,15.86,0,0,1,5.51-2.12c5.36-1.09,11.48-.13,15.23,3.86-1.77-1.35-4.25-.31-6.35.4-1.84.62-3.76,1-5.61,1.52a22,22,0,0,0-6.85,3.55c-1.24.94-4,5-5.46,4.9-2.64-.19-1.48-4.78-1-6.16A11.58,11.58,0,0,1,67.83,116.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9641",
    "data-name": "Trazado 9641",
    d: "M64.35,128.93h-.09a2.07,2.07,0,0,1-1.64-.93c-1.18-1.8.05-5.5.19-5.92a12.1,12.1,0,0,1,4.73-6.22h0a16.33,16.33,0,0,1,5.69-2.18c4.85-1,11.52-.46,15.71,4a.51.51,0,0,1,0,.7.52.52,0,0,1-.7.07c-1.39-1.07-3.39-.38-5.32.29l-.54.19c-1,.34-2.08.6-3.1.85-.83.2-1.7.42-2.53.67a21.41,21.41,0,0,0-6.68,3.47,15.43,15.43,0,0,0-1.63,1.7C66.74,127.55,65.44,128.93,64.35,128.93Zm13.1-14.65a19.734,19.734,0,0,0-4,.41,15,15,0,0,0-5.332,2h0a11,11,0,0,0-4.32,5.69c-.5,1.44-1,4-.31,5a1,1,0,0,0,.86.47c.67,0,2.34-1.84,3.33-3a16.079,16.079,0,0,1,1.78-1.84,22.38,22.38,0,0,1,7-3.63c.86-.27,1.74-.48,2.6-.69s2-.5,3-.83l.53-.18a12.93,12.93,0,0,1,3.85-.91A15.6,15.6,0,0,0,77.45,114.28ZM67.83,116.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9642",
    "data-name": "Trazado 9642",
    d: "M95.9,118.81a28.44,28.44,0,0,0-20.85-2c-6.69,2-10.88,7.44-12.44,14.15-1.08,4.61-1.92,11.72,1.84,15.14a27.44,27.44,0,0,0,14.67,6.69c5.7.89,12.78.76,17.52-2.92a22.53,22.53,0,0,0,8-16.1C104.88,126.67,101.17,121.71,95.9,118.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9643",
    "data-name": "Trazado 9643",
    d: "M84.76,153.79a37.479,37.479,0,0,1-5.72-.46,27.88,27.88,0,0,1-14.92-6.81c-3.84-3.49-3.21-10.42-2-15.62,1.71-7.32,6.37-12.61,12.79-14.52a29.09,29.09,0,0,1,21.23,2h0a16.43,16.43,0,0,1,9,15.47A23.12,23.12,0,0,1,97,150.31C93.43,153,88.78,153.79,84.76,153.79ZM83,116.23a28,28,0,0,0-7.83,1.1c-6.16,1.83-10.45,6.73-12.1,13.8-.94,4-2,11.32,1.7,14.65a26.8,26.8,0,0,0,14.4,6.56c4.2.67,12,1.18,17.15-2.82a22.06,22.06,0,0,0,7.82-15.71c.25-8-4.48-12.36-8.5-14.56h0A26.75,26.75,0,0,0,83,116.23Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9644",
    "data-name": "Trazado 9644",
    d: "M90.41,159.37l.86,12.06s-1.17,5.62-9.38,4.32S72.06,169,72.06,169l-.79-22.55s12.08-7.71,9.29-20.54c0,0,5.68,7,17.53,4.52,0,0,1.1,14.37.62,20.68S90.41,159.37,90.41,159.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9645",
    "data-name": "Trazado 9645",
    d: "M84.21,176.44a15,15,0,0,1-2.39-.2c-8.42-1.34-10.17-6.86-10.24-7.1a.51.51,0,0,1,0-.13l-.79-22.54A.48.48,0,0,1,71,146c.11-.08,11.75-7.69,9.07-20a.5.5,0,0,1,.27-.56.51.51,0,0,1,.61.14c0,.07,5.66,6.72,17,4.34a.56.56,0,0,1,.4.09.49.49,0,0,1,.2.37c0,.14,1.09,14.47.62,20.75-.43,5.82-6.59,8.08-8.27,8.59l.83,11.65a.66.66,0,0,1,0,.14C91.75,171.58,90.65,176.44,84.21,176.44Zm-11.65-7.53c.2.59,2,5.17,9.41,6.34,7.24,1.15,8.64-3.25,8.8-3.86l-.85-12a.5.5,0,0,1,.37-.52c.08,0,7.49-1.93,7.93-7.81.41-5.5-.39-17.32-.58-20-8.78,1.65-14.13-1.76-16.32-3.66,1.46,11.1-7.91,18.19-9.54,19.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9646",
    "data-name": "Trazado 9646",
    d: "M75,145.5a5.27,5.27,0,0,0-2-2.67,9.33,9.33,0,0,0-2.94-1.19,3.88,3.88,0,0,0-1.72-.17,3.11,3.11,0,0,0-1.11.51,4,4,0,0,0-1.78,2.19,4.76,4.76,0,0,0,.08,2.31,9.7,9.7,0,0,0,.81,2.4,6.41,6.41,0,0,0,8.71,2.65",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9647",
    "data-name": "Trazado 9647",
    d: "M72,152.8a6.78,6.78,0,0,1-2-.3,6.94,6.94,0,0,1-4.1-3.39,10.08,10.08,0,0,1-.86-2.53A5.29,5.29,0,0,1,65,144a4.53,4.53,0,0,1,2-2.48,3.76,3.76,0,0,1,1.29-.58,4.14,4.14,0,0,1,1.95.18,9.84,9.84,0,0,1,3.09,1.26,5.77,5.77,0,0,1,2.2,2.92.525.525,0,0,1-1,.32,4.77,4.77,0,0,0-1.82-2.42A8.92,8.92,0,0,0,70,142.12a3.4,3.4,0,0,0-1.49-.16,2.5,2.5,0,0,0-.94.44A3.63,3.63,0,0,0,66,144.3a4.29,4.29,0,0,0,.09,2.07,8.44,8.44,0,0,0,.77,2.27,5.9,5.9,0,0,0,8,2.45.5.5,0,0,1,.68.2.51.51,0,0,1-.2.68A6.9,6.9,0,0,1,72,152.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9648",
    "data-name": "Trazado 9648",
    d: "M88.4,139.93s4.93,5.79,4.06,7-3.75.81-3.75.81",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9649",
    "data-name": "Trazado 9649",
    d: "M89.77,148.3a10.309,10.309,0,0,1-1.13-.07.5.5,0,1,1,.14-.99c.67.09,2.71.17,3.27-.61.27-.55-1.61-3.54-4-6.38a.5.5,0,1,1,.76-.65c1.94,2.28,5,6.29,4.09,7.62A3.993,3.993,0,0,1,89.77,148.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9650",
    "data-name": "Trazado 9650",
    d: "M92.14,151.05l-9.51-3.27a6,6,0,0,0,1.63,6.87C88,158.3,92.14,151.05,92.14,151.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9651",
    "data-name": "Trazado 9651",
    d: "M86.51,156.18a3.66,3.66,0,0,1-2.6-1.18,6.58,6.58,0,0,1-1.72-7.45.5.5,0,0,1,.6-.25l9.51,3.27a.54.54,0,0,1,.31.3.48.48,0,0,1,0,.42c-.1.19-2.59,4.45-5.6,4.86A3.548,3.548,0,0,1,86.51,156.18Zm-3.59-7.78a5.61,5.61,0,0,0,1.7,5.89,2.54,2.54,0,0,0,2.22.86c2-.26,3.81-2.74,4.54-3.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9652",
    "data-name": "Trazado 9652",
    d: "M85.62,138.74a.52.52,0,0,1-.26-.08c-2.49-1.52-4-1-4-.94a.5.5,0,0,1-.38-.92c.08,0,2-.8,4.93,1a.5.5,0,0,1,.17.69A.51.51,0,0,1,85.62,138.74Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9653",
    "data-name": "Trazado 9653",
    d: "M91.77,138.75a.49.49,0,0,1-.37-.16.5.5,0,0,1,0-.71.48.48,0,0,1,.37-.14l.4-.22c.94-.54,2.89-1.67,4.78-.87a.5.5,0,1,1-.38.92c-1.44-.6-3,.32-3.9.81A2,2,0,0,1,91.77,138.75Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9654",
    "data-name": "Trazado 9654",
    d: "M90.41,159.37s-6.27.31-9.27-1.26c0,0,2.77,7,9.67,8.52Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9655",
    "data-name": "Trazado 9655",
    d: "M90.81,167.13h-.1c-7.08-1.52-9.91-8.53-10-8.83a.5.5,0,0,1,.13-.55.49.49,0,0,1,.56-.07c2.85,1.48,9,1.2,9,1.2a.49.49,0,0,1,.52.47l.4,7.26a.49.49,0,0,1-.5.53Zm-8.65-8.07c1,1.91,3.62,5.68,8.12,6.93l-.34-6.11a26.71,26.71,0,0,1-7.78-.82Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9656",
    "data-name": "Trazado 9656",
    d: "M59.35,203.57c1.86-6.83-4.44-18.83-6.24-24.86-1.66-5.55-9.28-20.14-7.84-25.84,0,0,3.49-13.85.16-11.78-1.88,1.17-3.19,6.88-3.19,6.88s-2.06-12.6-5.34-13.89-9.78,7-8.81,10.5c3.22,11.55,4.46,23.78,5.91,35.64,1.31,10.6,1.06,27.61,15.67,28.4C55.7,208.94,58.46,206.85,59.35,203.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9657",
    "data-name": "Trazado 9657",
    d: "M50.84,209.15h-1.2c-13.32-.71-14.7-14.68-15.71-24.89-.14-1.38-.27-2.7-.42-3.94s-.33-2.72-.5-4.09c-1.26-10.47-2.56-21.29-5.4-31.48-.68-2.45,1.82-6.78,4.59-9.27,1.86-1.68,3.59-2.32,4.88-1.82,2.69,1.06,4.49,8.33,5.26,12.11.58-1.83,1.55-4.27,2.83-5.06a1.22,1.22,0,0,1,1.48-.09c1.75,1.28-.25,9.82-.9,12.41-1,3.88,2.61,12.51,5.22,18.82,1.14,2.74,2.13,5.11,2.62,6.76s1.25,3.55,2.08,5.67c2.49,6.35,5.59,14.25,4.17,19.47h0C58.85,207.32,55.83,209.15,50.84,209.15Zm-14.69-74.7a5.52,5.52,0,0,0-3.28,1.73c-2.76,2.49-4.81,6.43-4.3,8.26,2.86,10.27,4.17,21.13,5.43,31.63.17,1.37.33,2.73.5,4.09s.29,2.58.42,4c1,10.4,2.31,23.33,14.78,24,5.23.28,8.24-1.25,9.17-4.68,1.34-4.9-1.7-12.63-4.13-18.84-.84-2.14-1.63-4.16-2.11-5.75s-1.45-3.94-2.58-6.66c-2.82-6.79-6.33-15.24-5.27-19.44,1.27-5,2.08-10.78,1.28-11.36a.759.759,0,0,0-.36.13c-1.4.87-2.62,5-3,6.56a.48.48,0,0,1-.5.39.51.51,0,0,1-.48-.42c-.56-3.43-2.56-12.53-5-13.5a1.47,1.47,0,0,0-.57-.14Zm23.2,69.12Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9658",
    "data-name": "Trazado 9658",
    d: "M35.07,154h-.12a.5.5,0,0,1-.37-.6c1-3.82,7.25-5.76,7.52-5.84a.5.5,0,0,1,.29.95c-.06,0-6,1.86-6.84,5.13A.49.49,0,0,1,35.07,154Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9659",
    "data-name": "Trazado 9659",
    d: "M104.66,204.74a.5.5,0,0,1-.49-.42L99.85,176a.51.51,0,0,1,.42-.57.49.49,0,0,1,.57.42l4.32,28.3a.5.5,0,0,1-.42.56Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9660",
    "data-name": "Trazado 9660",
    d: "M69.57,187a.39.39,0,0,1-.18,0,.5.5,0,0,1-.28-.65l5.38-13.6a.5.5,0,1,1,.93.37L70,186.72A.51.51,0,0,1,69.57,187Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9661",
    "data-name": "Trazado 9661",
    d: "M76.24,177.92a.45.45,0,0,1-.16,0L70.28,176a.51.51,0,0,1-.32-.63.52.52,0,0,1,.64-.32l5.8,1.94a.51.51,0,0,1,.31.64.49.49,0,0,1-.47.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9662",
    "data-name": "Trazado 9662",
    d: "M75,182.61a.58.58,0,0,1-.19,0l-5.9-2.38a.5.5,0,1,1,.37-.93l5.9,2.38a.508.508,0,0,1-.18,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9663",
    "data-name": "Trazado 9663",
    d: "M243.42,166A51.16,51.16,0,0,1,230,164a.5.5,0,0,1-.35-.61.49.49,0,0,1,.62-.35c11.36,3.08,19.07,1.79,23.54.17a17.82,17.82,0,0,0,7-4.28.5.5,0,1,1,.76.65C261.36,159.94,256,166,243.42,166Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9664",
    "data-name": "Trazado 9664",
    d: "M198.68,204.54a.49.49,0,0,1-.49-.41c-2.5-14.42,3.2-28.24,3.26-28.38a.51.51,0,0,1,.65-.27.5.5,0,0,1,.27.66c-.05.13-5.64,13.69-3.2,27.82a.5.5,0,0,1-.4.58Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModal);
export default __webpack_public_path__ + "static/media/info_modal.2435067cad74dd6439f766f7b66af185.svg";
export { ForwardRef as ReactComponent };